import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ItemSearchComponent } from '../../shared/components/popups/item-search/item-search.component';
import { CPQSelectionSummary, CPQUI } from '../../shared/models/CPQUI';
import { Distributor } from '../../shared/models/Distributor';
import { Item } from '../../shared/models/Item';
import { ItemPricing } from '../../shared/models/ItemPricing';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { CPQComponent } from '../cpq/cpq.component';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FilterObject } from '../../shared/models/FilterObject';
import { PagingResults } from '../../shared/models/PagingResult';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent implements OnInit {
  readonly Page: string = "Pricing";
  ConfigString: string;
  ItemList: Item[];
  CurrentCPQSessionID: string;
  CurrentCPQUI: CPQUI;
  CurrentDist: Distributor;
  DistSubscription: Subscription;
  HideDist: boolean;
  DistList: Distributor[];
  CurrentUser: User
  HideSearch: boolean;
  HideLookup: boolean;
  faSearch = faSearch;
  InvalidItem: boolean;
  OverrideBreakPricingRule: boolean;
  hideLoadingModal: boolean;
  MessagesForSummary: string[];
  constructor(private global: GlobalService, private router: Router, private http: HttpService, public matDialog: MatDialog) { }

  ngOnInit(): void {
    this.InvalidItem = false;
    this.hideLoadingModal = true;
    this.ItemList = [];
    this.ConfigString = "";
    this.CurrentDist = new Distributor();
    this.CurrentUser = new User();
    this.MessagesForSummary = [];
    this.global.getCurrentUser().then(x => {
      
      this.CurrentUser = x;
      
      if (!this.CurrentUser || this.CurrentUser == null) {
        this.router.navigate(['/']);
      }
      this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
        if (dist) {
          this.CurrentDist = dist;
        }
      });
      if (this.CurrentUser.IsTolomaticUser) {
        this.HideDist = false;
      }
      else {
        this.HideDist = true;
      }

      this.http.GetDistributors().then(x => {
        if (x.StatusCode == "200") {
          this.DistList = x.Content;
          this.DistList = this.DistList.filter(x => x.CstaccountNumber != null && x.CstaccountNumber.length > 0);
          this.global.getCurrentDist().then(dist => {
            if (dist) {
              if (!this.CurrentUser.IsTolomaticUser && this.CurrentUser.DistributorId == dist.CompanyId) {
                this.CurrentDist = dist;
              }
              else if (this.CurrentUser.IsTolomaticUser) {
                this.CurrentDist = dist;
              }
              else {
                this.CurrentDist = this.DistList.filter(x => x.CompanyId == this.CurrentUser.DistributorId)[0];
              }
            }
            else {
              if (!this.CurrentUser.IsTolomaticUser && this.CurrentUser.DistributorId != "") {
                this.CurrentDist = this.DistList.filter(x => x.CompanyId == this.CurrentUser.DistributorId)[0];
              } else {
                this.CurrentDist = this.DistList[0];
              }
            }
            this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Load", "", this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);

          });
          //look for state object to pre select distributor and filter(sort)
          var curNavigation = this.router.getCurrentNavigation();
          if (curNavigation) {
            var stateObject = curNavigation.extras.state;
            if (stateObject) {
              if (stateObject.distributor) {
                this.CurrentDist == stateObject.distributor;
              }
            }
          }
        }
      });
      this.global.CurrentDist.subscribe(dist => {
        if (dist) {
          this.CurrentDist = dist;
        }
      });

    });

  }

  LookupAnotherItem() {
    this.ConfigString = "";
    this.HideSearch = false;
  }

  PriceItem(itemNumber: string,trimEightDigit:boolean = true) {
    this.InvalidItem = false;
    if (this.ConfigString.length > 0) {
      this.hideLoadingModal = false;
      if (/^[\d]{1}/.test(this.ConfigString)) {//Eight digit part
        debugger;
        this.ConfigString = this.ConfigString.replace("-", "");
        //Have to get rid of everything after the 8 digits because CPQ isn't set up to decode all 8 digit configurables -- JWelter 12/03/2025
        if (trimEightDigit) {
          this.ConfigString = this.ConfigString.replace(" ", "").trim();
        } else {
          this.ConfigString = this.ConfigString.replace(" ", "")
        }
        
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Price 8-Digit Item", this.ConfigString, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);
        var FilterList = [];
        var ItemNumberSearch = new FilterObject();
        if (trimEightDigit) {
          itemNumber = itemNumber.replace("-", "").trim();
          ItemNumberSearch.Value = this.ConfigString.trim();
        } else {
          itemNumber = itemNumber.replace("-", "")
          ItemNumberSearch.Value = this.ConfigString;
        }
        
        
        ItemNumberSearch.Key = "item";
        //ItemNumberSearch.Value = this.ConfigString.trim();
        FilterList.push(ItemNumberSearch);
        var CustomerSearch = new FilterObject();
        CustomerSearch.Key = "customer";
        CustomerSearch.Value = "";
        if (this.CurrentDist && this.CurrentDist.Permissions && this.CurrentDist.Permissions.length > 0 && this.CurrentDist.Permissions.some(x => x.Page.toLowerCase() == "pricing" && x.Action.toLowerCase() == "contract")) {
          CustomerSearch.Value = this.CurrentDist.CstaccountNumber;
          this.OverrideBreakPricingRule = true;
          FilterList.push(CustomerSearch);
          this.http.AdvancedItemSearch(FilterList, 0, 10).then(x => {
            var results = <PagingResults>x;
            var foundItem;
            for (var i = 0; i < results.Items.length; i++) {
              foundItem = <Item>results.Items[i];
              break;
            }

            if (results.Items.length > 0 && foundItem && foundItem.OrderConfigurable) {//Means it's a 8 digit configured
              this.StartCPQProcess(true);
              this.hideLoadingModal = true;
            }
            else {
              this.http.GetBreakPricing(this.CurrentDist.CompanyId, itemNumber,itemNumber).then(wrap => {
                if (wrap.StatusCode == "200") {
                  this.HideSearch = true;

                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  newItem.Pricing = wrap.Content;
                  newItem.BuildPricing();
                  if (!newItem.Pricing || (newItem.Pricing.length > 0 && newItem.Pricing[0].ItemStatus == 'O')) {
                    this.OverrideBreakPricingRule = true;
                    newItem.EffectivePricing.OverridePricingRules = true;
                  }
                  this.ItemList.push(newItem);
                  this.BuildItemListIndexes();
                  this.hideLoadingModal = true;
                  this.ConfigString = "";
                  //this.PriceBreakComp.ItemPriceList.push(newItem);
                  //this.PriceBreakComp.BuildPricing();
                }
                else if (wrap.StatusCode == "300" && wrap.Content == true) {

                  this.HideSearch = true;
                  this.OverrideBreakPricingRule = true;
                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  newItem.Description = "Please contact Tolomatic to see pricing on this item."
                  newItem.Pricing = [];
                  var newPricing = new ItemPricing();
                  newPricing.ItemStatus = 'I';
                  newItem.EffectivePricing.OverridePricingRules = true;
                  newItem.Pricing.push(newPricing);

                  newItem.BuildPricing();
                  this.ItemList.push(newItem);
                  this.BuildItemListIndexes();
                  this.hideLoadingModal = true;
                  this.ConfigString = "";
                }
                else if (wrap.StatusCode == "400") {
                  this.OverrideBreakPricingRule = true;
                  this.HideSearch = true;
                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  newItem.EffectivePricing.OverridePricingRules = true;
                  this.ItemList.push(newItem);
                  this.BuildItemListIndexes();
                  this.hideLoadingModal = true;
                  this.ConfigString = "";
                }
                else {
                  //Didn't find an item
                  this.InvalidItem = true;
                  this.hideLoadingModal = true;
                }
              });
            }
          });
        } else {
          this.OverrideBreakPricingRule = false;
          CustomerSearch.Value = this.CurrentDist.CstaccountNumber;
          FilterList.push(CustomerSearch);
          this.http.ItemSearch(FilterList, 0, 10).then(x => {
            var results = <PagingResults>x;
            var foundItem;
            for (var i = 0; i < results.Items.length; i++) {
              foundItem = <Item>results.Items[i];
              break;
            }

            if (results.Items.length > 0 && foundItem && foundItem.OrderConfigurable) {//Means it's a 8 digit configured
              this.StartCPQProcess(true);
              this.hideLoadingModal = true;
            }
            else {
              this.http.GetBreakPricing(this.CurrentDist.CompanyId, itemNumber, itemNumber).then(wrap => {
                if (wrap.StatusCode == "200") {
                  this.HideSearch = true;


                  var newItem = new Item();
                  newItem.Item = itemNumber;
                  newItem.Pricing = wrap.Content;
                  newItem.BuildPricing();
                  if (newItem.Pricing.length > 0 && newItem.Pricing[0].ItemStatus == 'O') {
                    this.OverrideBreakPricingRule = true;
                    newItem.EffectivePricing.OverridePricingRules = true;
                  }
                  this.ItemList.push(newItem);
                  this.BuildItemListIndexes();
                  this.hideLoadingModal = true;
                  this.ConfigString = "";

                } else if (wrap.StatusCode == "300") {
                  //Didn't find an item
                  this.InvalidItem = true;
                  this.hideLoadingModal = true;
                  this.ConfigString = "";
                } else if (wrap.StatusCode == "400") {
                  this.InvalidItem = true;
                  this.hideLoadingModal = true;
                  this.ConfigString = "";
                }
              });
            }

          });

        }


      }
      else {//config string

        //this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Quick Price", "Price Configured Item", this.ConfigString);
        this.StartCPQProcess(false);
        this.hideLoadingModal = true;
      }
    }
    //this.InvalidItem = false;
    //if (item.length > 0) {
    //  if (/^[\d]{1}/.test(item)) {

    //    var ItemNumberSearch = new FilterObject();
    //    ItemNumberSearch.Key = "item";
    //    ItemNumberSearch.Value = this.ConfigString.replace("-", "");
    //    item = item.replace("-", "");
    //    this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Price 8-Digit Item",item);
    //    var FilterList = [];
    //    FilterList.push(ItemNumberSearch);
    //    this.http.ItemSearch(FilterList, 0, 10).then(x => {
    //      var results = <PagingResults>x;
    //      var foundItem;
    //      for (var i = 0; i < results.Items.length; i++) {
    //        foundItem = <Item>results.Items[i];
    //        break;
    //      }

    //      if (results.Items.length > 0 && foundItem && foundItem.OrderConfigurable) {//8 Digit configured

    //        this.StartCPQProcess(true);
    //      }
    //      else {
    //        this.http.GetBreakPricing(this.CurrentDist.CompanyId, item).then(wrap => {
    //          if (wrap.StatusCode == "200") {
    //            if (wrap.Content) {
    //              this.HideSearch = true;
    //              //this.ShowBreakPrice = true;
    //              var newItem = new Item();
    //              newItem.Item = item;

    //              newItem.Pricing = wrap.Content;

    //              newItem.BuildPricing();
    //              this.ItemList.push(newItem);
    //              this.BuildItemListIndexes();
    //              this.ConfigString = "";
    //              debugger;

    //            }
    //          }
    //        });
    //      }
    //      //else {
    //      //  this.InvalidItem = true;
    //      //}
    //    });
    //  }
    //  else {//config string

    //    //this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Price Configured Item");
    //    this.StartCPQProcess(false);

    //  }
    //} 
  }

  StartCPQProcess(openUI: boolean) {
    if (openUI) {
      this.CreateNewConfig(null);
    }
    else {
      this.http.CPQConfigureStart(this.ConfigString, true).then(wrap => {
        //this.hideLoadingModal = false;
        this.CurrentCPQSessionID = wrap.Content;
        this.http.CPQInitialize(this.CurrentCPQSessionID).then(wrap2 => {
          this.CurrentCPQSessionID = wrap2.Content;

          this.http.CPQConfigureUpdate(this.CurrentCPQSessionID, "", "").then(wrap3 => {
            var cpqUI = <CPQUI>wrap3.Content;
            this.MessagesForSummary = [];
            if (this.CheckForRequired(cpqUI)) {
              var temp = this.PullPriceFromCPQUI(cpqUI);
              var messages = this.PullMessagesFromCPQUI(cpqUI);

              
              var selSummary = this.getSelectionSummaryFromCPQUI(cpqUI);
              var cpqConfigString = this.getConfigStringFromCPQUI(cpqUI);
              this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Price Configured Item", this.ConfigString, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);
              this.PriceConfigured(cpqConfigString, temp, selSummary);

            }
            else {
              this.CreateNewConfig(cpqUI);
            }

          });
        });
      });
    }
  }

  CheckForRequired(cpq: CPQUI) {
    var isValid = true;
    cpq.Pages.forEach(page => {
      page.Screens.forEach(screen => {
        screen.ScreenOptions.forEach(opt => {
          if (opt.IsRequired && (opt.Value == "")) {
            isValid = false;
          }
          else if (opt.IsValid == false) {
            isValid = false;
          }
        });
      });
    });
    return isValid;
  }

  PullPriceFromCPQUI(cpq: CPQUI): number {
    debugger;
    var priceDetails = cpq.Details.filter(x => x.Caption.toLowerCase().indexOf('price') >= 0);
    var totalPrice = 0.0;
    //priceDetails.forEach(price => {
    //  totalPrice += this.ParseCurrency(price.Value, 2);
    //});

    //this.CurrentPrice = totalPrice;
    var lastPrice = priceDetails[priceDetails.length - 1];
    if (lastPrice && lastPrice.Value) {
      return this.ParseCurrency(lastPrice.Value, 2);
      //this.ActionButtonDisabled = false;
    }
    else {
      return 0;
    }
  }

  BuildItemListIndexes() {
    for (var i = 0; i < this.ItemList.length; i++) {
      this.ItemList[i].Index = i;
    }
  }

  SearchForItem() {
    var dialogConfig = {
      width: '60%',
      height: '80%'
    };
    var currentDialog = this.matDialog.open(ItemSearchComponent, dialogConfig);

    currentDialog.componentInstance.EnteredItemNumber = this.ConfigString;
    currentDialog.componentInstance.ItemSelectEmitter.subscribe(item => {
      if (item) {
        this.ConfigString = item.Item;
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Item Search", this.ConfigString, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);
        this.PriceItem(item.Item,false);
        currentDialog.close();
      }
    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  CreateNewConfig(cpqUI: CPQUI) {
    var dialogConfig = {
      width: '80%',
      height: '80%'
    };
    var currentDialog = this.matDialog.open(CPQComponent, dialogConfig);
    currentDialog.componentInstance.EnteredCFGString = this.ConfigString;

    if (cpqUI) {
      currentDialog.componentInstance.CurrentCPQUI = cpqUI;
      currentDialog.componentInstance.CurrentCPQSessionID = this.CurrentCPQSessionID;
    }
    this.hideLoadingModal = true;
    currentDialog.componentInstance.ActionEventEmitter.subscribe((event) => {
      //this.ShowBreakPrice = false;
      var args = event;
      var newItem = new Item();
      newItem.Item = args.configString;
      this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Pricing", "Price Configured Item", newItem.Item, this.CurrentUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurrentUser.DistributorId);
      this.PriceConfigured(newItem.Item, args.CurrentPrice, args.selectionSummary);
      //var pricing = new ItemPricing();
      //pricing.UnitPrice = args.CurrentPrice;
      //newItem.Pricing.push(pricing);
      //newItem.BuildPricing();
      //this.ItemList.push(newItem);

      currentDialog.close();
      //var product = newItem.Item.substring(0,newItem.Item.indexOf(' '));
      //this.http.GetBreakPricing(this.CurrentDist, product).then(wrap => {
      //  if (wrap.StatusCode == "200") {
      //    var pricing = wrap.Content[0];
      //    pricing.Item = newItem.Item;
      //    pricing.UnitPrice = this.ParseCurrency(args[0], 2);
      //    newItem.Pricing.push(pricing);
      //    this.ItemList.push(newItem);
      //  }
      //  currentDialog.close();
      //});

    });

    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      this.ConfigString = "";
      currentDialog.close();
    });
  }

  PriceConfigured(configuredString: string, configuredPrice: number, selectionSummary: string) {
    var productRegex = /^([0-9]{8}|CC|PB|MG|LS|IMA[S]?|BC[2-4]|[A-Z]{2,3}|[A-Z][\d][A-Z])/i;
    var configReg = productRegex.exec(configuredString);
    var item = configReg[0];
    debugger;
    this.http.GetBreakPricing(this.CurrentDist.CompanyId, item,configuredString).then(wrap => {
      if (wrap.StatusCode == "200") {
        if (wrap.Content) {
          this.HideSearch = true;
          //this.ShowBreakPrice = true;
          var newItem = new Item();
          newItem.Item = configuredString;
          newItem.ConfigHasChanged = configuredString != this.ConfigString && this.ConfigString != "";
          this.ConfigString = "";
          newItem.SelectionSummary = selectionSummary;
          newItem.Pricing = wrap.Content;
          newItem.Pricing.forEach(x => {
            x.UnitPrice = configuredPrice;
          });
          newItem.BuildPricing();
          this.ItemList.push(newItem);
          this.BuildItemListIndexes();

          this.hideLoadingModal = true;
        } else {
          this.hideLoadingModal = true;
        }
      }
      else if (wrap.StatusCode == "300" && wrap.Content == true) {
        this.HideSearch = true;
        this.OverrideBreakPricingRule = true;
        var newItem = new Item();
        newItem.Item = configuredString;
        newItem.SelectionSummary = selectionSummary;
        newItem.ConfigHasChanged = configuredString != this.ConfigString && this.ConfigString != "";
        this.ConfigString = "";
        newItem.Description = "Please contact Tolomatic to see pricing on this item.";
        this.OverrideBreakPricingRule = true;
        newItem.EffectivePricing.OverridePricingRules = true;
        newItem.Pricing = [];
        var newPricing = new ItemPricing();
        newPricing.ItemStatus = 'O';
        newItem.Pricing.push(newPricing);

        newItem.BuildPricing();
        this.ItemList.push(newItem);
        this.BuildItemListIndexes();
        this.hideLoadingModal = true;
      }
      this.hideLoadingModal = true;
      this.ConfigString = "";
      //return new ItemPricing();
    });
  }

  ParseCurrency(str: string, precision: number) {
    return Number(str.slice(0, (str.indexOf('.')) + precision + 1));
  }

  Dist_Change(event: any) {
    var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
    this.CurrentDist = newDist;

    this.global.setCurrentDist(newDist);

  }

  getSelectionSummaryFromCPQUI(cpq: CPQUI): string {
    debugger;
    var summary = "";
    var selectionArray = [];
    cpq.SelectionSummary.forEach(ss => {
      if ((ss.Caption && ss.Value) && ss.Caption.length > 0 && ss.Value.length > 0 && (ss.Value != "No" && ss.Value != "None" && ss.Value != "False")) {
        var newSum = new CPQSelectionSummary();
        newSum.Caption = this.stripTags(ss.Caption);
        newSum.Value = ss.Value;
        selectionArray.push(newSum);
      }
    });

    cpq.Details.forEach(detail => {

      if (detail.Caption.toLowerCase().indexOf("selection summary") < 0 && detail.Caption.toLowerCase().indexOf("price") < 0 && detail.Value == "" && detail.Caption.length > 0) {
        summary += "<span>" + this.stripTags(detail.Caption) + "</span><br />";
      }
    });

    if (this.MessagesForSummary.length > 0) {
      for (var i = 0; i < this.MessagesForSummary.length; i++) {
        summary += "<span>" + this.MessagesForSummary[i] + "</span><br />";
      }
    }


    return summary;
  }

  getConfigStringFromCPQUI(cpq: CPQUI): string {
    var config = "";

    if (cpq && cpq.Details && cpq.Details.length > 0) {
      var filtered = cpq.Details.filter(x => x.Caption.toLowerCase() == "config string")[0];
      if (filtered) {
        config = filtered.Value;
      }
    }

    //if (config == "") {
    //  config = this.ConfigString;
    //}

    return config;
  }

  stripTags(input: string): string {
    return input.replace(/(<([^>]+)>)/gi, "");
  }

  PullMessagesFromCPQUI(cpq: CPQUI): string {
    debugger;
    var messages = "";
    var dupeCheck = [];
    for (var i = 0; i < cpq.Messages.length; i++) {
      if (cpq.Messages[i].Value.indexOf("Note:") >= 0) {
        if (dupeCheck.filter(x => x == cpq.Messages[i].Value).length == 0) {
          if (cpq.Messages[i].Value.toLowerCase().indexOf('config string') < 0) {
            messages += cpq.Messages[i].Value + "\r\n";
            dupeCheck.push(cpq.Messages[i].Value);
          }
        }
      }
    }
    for (var i = 0; i < dupeCheck.length; i++) {
      if (this.MessagesForSummary.filter(x => x == dupeCheck[i]).length == 0) {
        this.MessagesForSummary.push(dupeCheck[i]);
      }
    }
    var htmlRegex = /[<].*?[>]/g;//new RegExp('[<].*[>]');

    messages = messages.replace(htmlRegex, '');

    messages = messages.trimLeft();
    return messages;
  }

}
